// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app {
  min-height: 100vh;
  background-color: #f0f2f5;
}

/* Header */
.header {
  background: linear-gradient(135deg, #f15a22 0%, #d94d1a 100%);
  color: white;
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.header h1 {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
}

.header-info {
  font-size: 0.875rem;
  opacity: 0.9;
}

/* Tabs */
.tabs {
  display: flex;
  gap: 0;
  background: white;
  border-bottom: 1px solid #e2e8f0;
  padding: 0 2rem;
}

.tab {
  padding: 1rem 1.5rem;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 0.875rem;
  color: #64748b;
  border-bottom: 3px solid transparent;
  transition: all 0.2s;
}

.tab:hover {
  color: #f15a22;
}

.tab.active {
  color: #f15a22;
  border-bottom-color: #f15a22;
  font-weight: 600;
}

/* Filters */
.filters {
  display: flex;
  gap: 0.75rem;
  padding: 1rem 2rem;
  background: white;
  border-bottom: 1px solid #e2e8f0;
  flex-wrap: wrap;
  align-items: center;
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.filter-label {
  font-size: 0.75rem;
  color: #64748b;
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.filter-select {
  padding: 0.5rem 0.75rem;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 0.875rem;
  background: white;
  min-width: 120px;
  cursor: pointer;
}

.filter-select:focus {
  outline: none;
  border-color: #f15a22;
}

/* MultiSelect */
.multi-select {
  position: relative;
  min-width: 150px;
}

.multi-select-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 0.75rem;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 0.875rem;
  cursor: pointer;
  background: white;
  transition: border-color 0.2s;
  min-height: 36px;
  -webkit-user-select: none;
          user-select: none;
}

.multi-select-trigger:hover {
  border-color: #cbd5e1;
}

.multi-select-text {
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #334155;
}

.multi-select-arrow {
  flex-shrink: 0;
  color: #94a3b8;
  transition: transform 0.2s;
  margin-left: 0.5rem;
}

.multi-select-arrow.open {
  transform: rotate(180deg);
}

.multi-select-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  z-index: 1000;
  max-height: 220px;
  overflow-y: auto;
  padding: 0.25rem 0;
  min-width: 180px;
}

.multi-select-option {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.4rem 0.75rem;
  cursor: pointer;
  font-size: 0.825rem;
  color: #334155;
  transition: background-color 0.15s;
  -webkit-user-select: none;
          user-select: none;
}

.multi-select-option:hover {
  background-color: #fff5f2;
}

.multi-select-option input[type="checkbox"] {
  width: 15px;
  height: 15px;
  accent-color: #f15a22;
  cursor: pointer;
  flex-shrink: 0;
  pointer-events: none;
}

.multi-select-option span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.multi-select-clear {
  color: #e53e3e;
  font-size: 0.8rem;
  border-bottom: 1px solid #f1f5f9;
  padding-bottom: 0.4rem;
  margin-bottom: 0.25rem;
}

.multi-select-clear:hover {
  background-color: #fed7d7;
}

.multi-select-empty {
  padding: 0.75rem;
  text-align: center;
  color: #94a3b8;
  font-size: 0.8rem;
}

.filter-input {
  padding: 0.5rem 0.75rem;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 0.875rem;
  background: white;
}

.filter-input:focus {
  outline: none;
  border-color: #f15a22;
}

/* Main Content */
.main-content {
  padding: 1.5rem 2rem;
  max-width: 1800px;
  margin: 0 auto;
}

/* Cards Grid */
.cards-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.cards-grid-3 {
  grid-template-columns: repeat(3, 1fr);
}

/* Card */
.card {
  background: white;
  border-radius: 8px;
  padding: 1.25rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  position: relative;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.5rem;
}

.card-title {
  font-size: 0.75rem;
  color: #64748b;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.card-menu {
  color: #94a3b8;
  cursor: pointer;
}

.card-value {
  font-size: 2rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0.25rem 0;
}

.card-value.time {
  font-size: 1.75rem;
  font-family: 'Courier New', monospace;
}

.card-subtitle {
  font-size: 0.75rem;
  color: #94a3b8;
}

/* Progress Bar Card */
.progress-card {
  padding: 1rem 1.25rem;
}

.progress-container {
  margin-top: 0.75rem;
}

.progress-bar {
  height: 32px;
  background: #e2e8f0;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
}

.progress-fill {
  height: 100%;
  display: flex;
  align-items: center;
  padding-left: 0.75rem;
  color: white;
  font-size: 0.75rem;
  font-weight: 500;
  transition: width 0.5s ease;
}

.progress-fill.success {
  background: linear-gradient(90deg, #38a169 0%, #48bb78 100%);
}

.progress-fill.warning {
  background: linear-gradient(90deg, #d69e2e 0%, #ecc94b 100%);
}

.progress-fill.danger {
  background: linear-gradient(90deg, #e53e3e 0%, #fc8181 100%);
}

.progress-label {
  display: flex;
  justify-content: space-between;
  margin-top: 0.5rem;
  font-size: 0.7rem;
  color: #94a3b8;
}

.meta-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0.5rem;
  background: #c6f6d5;
  color: #22543d;
  border-radius: 4px;
  font-size: 0.7rem;
  font-weight: 500;
  margin-top: 0.5rem;
}

.meta-badge.warning {
  background: #fefcbf;
  color: #744210;
}

.meta-badge.danger {
  background: #fed7d7;
  color: #742a2a;
}

/* Metric Value with Percentage */
.metric-row {
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
}

.metric-percent {
  font-size: 1.25rem;
  color: #64748b;
}

/* Pie Chart Card */
.pie-card {
  grid-column: span 1;
}

.pie-container {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: 0.5rem;
}

.pie-legend {
  flex: 1 1;
}

.pie-legend-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  font-size: 0.75rem;
}

.pie-legend-color {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.pie-legend-value {
  margin-left: auto;
  font-weight: 600;
}

/* Operators Grid */
.operators-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.operator-card {
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  text-align: center;
}

.operator-value {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1e293b;
}

.operator-label {
  font-size: 0.75rem;
  color: #64748b;
  margin-top: 0.25rem;
}

/* Section Title */
.section-title {
  font-size: 0.875rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* Charts Section */
.charts-section {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
}

.chart-card {
  background: white;
  border-radius: 8px;
  padding: 1.25rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.chart-card h3 {
  font-size: 0.875rem;
  color: #1e293b;
  margin-bottom: 1rem;
  font-weight: 600;
}

/* Table */
.table-container {
  overflow-x: auto;
  margin-top: 1rem;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.8rem;
}

.data-table th {
  background: #f8fafc;
  padding: 0.75rem 0.5rem;
  text-align: left;
  font-weight: 600;
  color: #475569;
  border-bottom: 2px solid #e2e8f0;
  white-space: nowrap;
}

.data-table td {
  padding: 0.625rem 0.5rem;
  border-bottom: 1px solid #f1f5f9;
  color: #334155;
}

.data-table tr:hover {
  background: #f8fafc;
}

.data-table .total-row {
  background: #f1f5f9;
  font-weight: 600;
}

.data-table .total-row td {
  border-bottom: none;
}

/* NPS Charts Grid */
.nps-charts-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  margin-top: 1.5rem;
}

.nps-chart-card {
  background: white;
  border-radius: 8px;
  padding: 1.25rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.nps-chart-card h4 {
  font-size: 0.8rem;
  color: #1e293b;
  margin-bottom: 1rem;
  font-weight: 600;
}

/* Loading State */
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  color: #64748b;
  flex-direction: column;
  gap: 1rem;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #e2e8f0;
  border-top-color: #f15a22;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Error State */
.error {
  background: #fed7d7;
  color: #c53030;
  padding: 1rem;
  border-radius: 8px;
  text-align: center;
  margin: 1rem 0;
}

/* Responsive */
@media (max-width: 1200px) {
  .cards-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .operators-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .nps-charts-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .header {
    flex-direction: column;
    gap: 0.5rem;
    text-align: center;
  }

  .main-content {
    padding: 1rem;
  }

  .cards-grid {
    grid-template-columns: 1fr;
  }

  .operators-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .filters {
    flex-direction: column;
    align-items: stretch;
  }

  .filter-select {
    width: 100%;
  }
}

/* Status Colors */
.status-atendida {
  color: #38a169;
}

.status-abandono-ura {
  color: #e53e3e;
}

.status-abandono {
  color: #805ad5;
}

/* Recharts custom */
.recharts-wrapper {
  font-size: 0.75rem;
}

/* Two column layout */
.two-columns {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
}

@media (max-width: 1024px) {
  .two-columns {
    grid-template-columns: 1fr;
  }
}

/* Records Header */
.records-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.records-header h3 {
  margin: 0;
  display: flex;
  align-items: center;
}

.records-count {
  font-size: 0.875rem;
  color: #64748b;
  background: #f1f5f9;
  padding: 0.5rem 1rem;
  border-radius: 20px;
}

/* Status Badge */
.status-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 500;
  white-space: nowrap;
}

/* Records Table */
.records-table td {
  font-size: 0.8rem;
}

/* Pagination */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid #e2e8f0;
}

.pagination-btn {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.5rem 1rem;
  border: 1px solid #e2e8f0;
  background: white;
  border-radius: 6px;
  font-size: 0.875rem;
  cursor: pointer;
  color: #334155;
  transition: all 0.2s;
}

.pagination-btn:hover:not(:disabled) {
  background: #fff5f2;
  border-color: #f15a22;
  color: #f15a22;
}

.pagination-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination-info {
  font-size: 0.875rem;
  color: #64748b;
}

/* Records Filters */
.records-filters {
  display: flex;
  gap: 0.75rem;
  padding: 1rem 0;
  margin-bottom: 1rem;
  border-bottom: 1px solid #e2e8f0;
  flex-wrap: wrap;
  align-items: center;
}

/* Export Button */
.export-btn {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.5rem 1rem;
  background: #f15a22;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.export-btn:hover {
  background: #d94d1a;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(241, 90, 34, 0.3);
}

/* Search Button */
.search-btn {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.5rem 1rem;
  background: #f15a22;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.search-btn:hover {
  background: #d94d1a;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,SAAS;AACT;EACE,aAAa;EACb,MAAM;EACN,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,kCAAkC;EAClC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gCAAgC;EAChC,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,SAAS;AACT;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,0BAA0B;EAC1B,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,kBAAkB;AAClB;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".app {\n  min-height: 100vh;\n  background-color: #f0f2f5;\n}\n\n/* Header */\n.header {\n  background: linear-gradient(135deg, #f15a22 0%, #d94d1a 100%);\n  color: white;\n  padding: 1rem 2rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.header h1 {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n.header-info {\n  font-size: 0.875rem;\n  opacity: 0.9;\n}\n\n/* Tabs */\n.tabs {\n  display: flex;\n  gap: 0;\n  background: white;\n  border-bottom: 1px solid #e2e8f0;\n  padding: 0 2rem;\n}\n\n.tab {\n  padding: 1rem 1.5rem;\n  border: none;\n  background: none;\n  cursor: pointer;\n  font-size: 0.875rem;\n  color: #64748b;\n  border-bottom: 3px solid transparent;\n  transition: all 0.2s;\n}\n\n.tab:hover {\n  color: #f15a22;\n}\n\n.tab.active {\n  color: #f15a22;\n  border-bottom-color: #f15a22;\n  font-weight: 600;\n}\n\n/* Filters */\n.filters {\n  display: flex;\n  gap: 0.75rem;\n  padding: 1rem 2rem;\n  background: white;\n  border-bottom: 1px solid #e2e8f0;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.filter-group {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.filter-label {\n  font-size: 0.75rem;\n  color: #64748b;\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.filter-select {\n  padding: 0.5rem 0.75rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 0.875rem;\n  background: white;\n  min-width: 120px;\n  cursor: pointer;\n}\n\n.filter-select:focus {\n  outline: none;\n  border-color: #f15a22;\n}\n\n/* MultiSelect */\n.multi-select {\n  position: relative;\n  min-width: 150px;\n}\n\n.multi-select-trigger {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.5rem 0.75rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 0.875rem;\n  cursor: pointer;\n  background: white;\n  transition: border-color 0.2s;\n  min-height: 36px;\n  user-select: none;\n}\n\n.multi-select-trigger:hover {\n  border-color: #cbd5e1;\n}\n\n.multi-select-text {\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #334155;\n}\n\n.multi-select-arrow {\n  flex-shrink: 0;\n  color: #94a3b8;\n  transition: transform 0.2s;\n  margin-left: 0.5rem;\n}\n\n.multi-select-arrow.open {\n  transform: rotate(180deg);\n}\n\n.multi-select-dropdown {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  right: 0;\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);\n  z-index: 1000;\n  max-height: 220px;\n  overflow-y: auto;\n  padding: 0.25rem 0;\n  min-width: 180px;\n}\n\n.multi-select-option {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.4rem 0.75rem;\n  cursor: pointer;\n  font-size: 0.825rem;\n  color: #334155;\n  transition: background-color 0.15s;\n  user-select: none;\n}\n\n.multi-select-option:hover {\n  background-color: #fff5f2;\n}\n\n.multi-select-option input[type=\"checkbox\"] {\n  width: 15px;\n  height: 15px;\n  accent-color: #f15a22;\n  cursor: pointer;\n  flex-shrink: 0;\n  pointer-events: none;\n}\n\n.multi-select-option span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.multi-select-clear {\n  color: #e53e3e;\n  font-size: 0.8rem;\n  border-bottom: 1px solid #f1f5f9;\n  padding-bottom: 0.4rem;\n  margin-bottom: 0.25rem;\n}\n\n.multi-select-clear:hover {\n  background-color: #fed7d7;\n}\n\n.multi-select-empty {\n  padding: 0.75rem;\n  text-align: center;\n  color: #94a3b8;\n  font-size: 0.8rem;\n}\n\n.filter-input {\n  padding: 0.5rem 0.75rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 0.875rem;\n  background: white;\n}\n\n.filter-input:focus {\n  outline: none;\n  border-color: #f15a22;\n}\n\n/* Main Content */\n.main-content {\n  padding: 1.5rem 2rem;\n  max-width: 1800px;\n  margin: 0 auto;\n}\n\n/* Cards Grid */\n.cards-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.cards-grid-3 {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n/* Card */\n.card {\n  background: white;\n  border-radius: 8px;\n  padding: 1.25rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n  position: relative;\n}\n\n.card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 0.5rem;\n}\n\n.card-title {\n  font-size: 0.75rem;\n  color: #64748b;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.card-menu {\n  color: #94a3b8;\n  cursor: pointer;\n}\n\n.card-value {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #1e293b;\n  margin: 0.25rem 0;\n}\n\n.card-value.time {\n  font-size: 1.75rem;\n  font-family: 'Courier New', monospace;\n}\n\n.card-subtitle {\n  font-size: 0.75rem;\n  color: #94a3b8;\n}\n\n/* Progress Bar Card */\n.progress-card {\n  padding: 1rem 1.25rem;\n}\n\n.progress-container {\n  margin-top: 0.75rem;\n}\n\n.progress-bar {\n  height: 32px;\n  background: #e2e8f0;\n  border-radius: 4px;\n  overflow: hidden;\n  position: relative;\n}\n\n.progress-fill {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  padding-left: 0.75rem;\n  color: white;\n  font-size: 0.75rem;\n  font-weight: 500;\n  transition: width 0.5s ease;\n}\n\n.progress-fill.success {\n  background: linear-gradient(90deg, #38a169 0%, #48bb78 100%);\n}\n\n.progress-fill.warning {\n  background: linear-gradient(90deg, #d69e2e 0%, #ecc94b 100%);\n}\n\n.progress-fill.danger {\n  background: linear-gradient(90deg, #e53e3e 0%, #fc8181 100%);\n}\n\n.progress-label {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 0.5rem;\n  font-size: 0.7rem;\n  color: #94a3b8;\n}\n\n.meta-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0.25rem 0.5rem;\n  background: #c6f6d5;\n  color: #22543d;\n  border-radius: 4px;\n  font-size: 0.7rem;\n  font-weight: 500;\n  margin-top: 0.5rem;\n}\n\n.meta-badge.warning {\n  background: #fefcbf;\n  color: #744210;\n}\n\n.meta-badge.danger {\n  background: #fed7d7;\n  color: #742a2a;\n}\n\n/* Metric Value with Percentage */\n.metric-row {\n  display: flex;\n  align-items: baseline;\n  gap: 0.5rem;\n}\n\n.metric-percent {\n  font-size: 1.25rem;\n  color: #64748b;\n}\n\n/* Pie Chart Card */\n.pie-card {\n  grid-column: span 1;\n}\n\n.pie-container {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-top: 0.5rem;\n}\n\n.pie-legend {\n  flex: 1;\n}\n\n.pie-legend-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 0.5rem;\n  font-size: 0.75rem;\n}\n\n.pie-legend-color {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n}\n\n.pie-legend-value {\n  margin-left: auto;\n  font-weight: 600;\n}\n\n/* Operators Grid */\n.operators-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.operator-card {\n  background: white;\n  border-radius: 8px;\n  padding: 1.5rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n  text-align: center;\n}\n\n.operator-value {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: #1e293b;\n}\n\n.operator-label {\n  font-size: 0.75rem;\n  color: #64748b;\n  margin-top: 0.25rem;\n}\n\n/* Section Title */\n.section-title {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #1e293b;\n  margin-bottom: 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n/* Charts Section */\n.charts-section {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.chart-card {\n  background: white;\n  border-radius: 8px;\n  padding: 1.25rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n\n.chart-card h3 {\n  font-size: 0.875rem;\n  color: #1e293b;\n  margin-bottom: 1rem;\n  font-weight: 600;\n}\n\n/* Table */\n.table-container {\n  overflow-x: auto;\n  margin-top: 1rem;\n}\n\n.data-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.8rem;\n}\n\n.data-table th {\n  background: #f8fafc;\n  padding: 0.75rem 0.5rem;\n  text-align: left;\n  font-weight: 600;\n  color: #475569;\n  border-bottom: 2px solid #e2e8f0;\n  white-space: nowrap;\n}\n\n.data-table td {\n  padding: 0.625rem 0.5rem;\n  border-bottom: 1px solid #f1f5f9;\n  color: #334155;\n}\n\n.data-table tr:hover {\n  background: #f8fafc;\n}\n\n.data-table .total-row {\n  background: #f1f5f9;\n  font-weight: 600;\n}\n\n.data-table .total-row td {\n  border-bottom: none;\n}\n\n/* NPS Charts Grid */\n.nps-charts-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 1rem;\n  margin-top: 1.5rem;\n}\n\n.nps-chart-card {\n  background: white;\n  border-radius: 8px;\n  padding: 1.25rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n\n.nps-chart-card h4 {\n  font-size: 0.8rem;\n  color: #1e293b;\n  margin-bottom: 1rem;\n  font-weight: 600;\n}\n\n/* Loading State */\n.loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 300px;\n  color: #64748b;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid #e2e8f0;\n  border-top-color: #f15a22;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Error State */\n.error {\n  background: #fed7d7;\n  color: #c53030;\n  padding: 1rem;\n  border-radius: 8px;\n  text-align: center;\n  margin: 1rem 0;\n}\n\n/* Responsive */\n@media (max-width: 1200px) {\n  .cards-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .operators-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .nps-charts-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .header {\n    flex-direction: column;\n    gap: 0.5rem;\n    text-align: center;\n  }\n\n  .main-content {\n    padding: 1rem;\n  }\n\n  .cards-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .operators-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .filters {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .filter-select {\n    width: 100%;\n  }\n}\n\n/* Status Colors */\n.status-atendida {\n  color: #38a169;\n}\n\n.status-abandono-ura {\n  color: #e53e3e;\n}\n\n.status-abandono {\n  color: #805ad5;\n}\n\n/* Recharts custom */\n.recharts-wrapper {\n  font-size: 0.75rem;\n}\n\n/* Two column layout */\n.two-columns {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.5rem;\n}\n\n@media (max-width: 1024px) {\n  .two-columns {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Records Header */\n.records-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.records-header h3 {\n  margin: 0;\n  display: flex;\n  align-items: center;\n}\n\n.records-count {\n  font-size: 0.875rem;\n  color: #64748b;\n  background: #f1f5f9;\n  padding: 0.5rem 1rem;\n  border-radius: 20px;\n}\n\n/* Status Badge */\n.status-badge {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n/* Records Table */\n.records-table td {\n  font-size: 0.8rem;\n}\n\n/* Pagination */\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n  margin-top: 1.5rem;\n  padding-top: 1rem;\n  border-top: 1px solid #e2e8f0;\n}\n\n.pagination-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0.5rem 1rem;\n  border: 1px solid #e2e8f0;\n  background: white;\n  border-radius: 6px;\n  font-size: 0.875rem;\n  cursor: pointer;\n  color: #334155;\n  transition: all 0.2s;\n}\n\n.pagination-btn:hover:not(:disabled) {\n  background: #fff5f2;\n  border-color: #f15a22;\n  color: #f15a22;\n}\n\n.pagination-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pagination-info {\n  font-size: 0.875rem;\n  color: #64748b;\n}\n\n/* Records Filters */\n.records-filters {\n  display: flex;\n  gap: 0.75rem;\n  padding: 1rem 0;\n  margin-bottom: 1rem;\n  border-bottom: 1px solid #e2e8f0;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n/* Export Button */\n.export-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.375rem;\n  padding: 0.5rem 1rem;\n  background: #f15a22;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.export-btn:hover {\n  background: #d94d1a;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(241, 90, 34, 0.3);\n}\n\n/* Search Button */\n.search-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.375rem;\n  padding: 0.5rem 1rem;\n  background: #f15a22;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.search-btn:hover {\n  background: #d94d1a;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
